import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from 'motion/react';
import { CheckCircle, TrendingDown, Zap, Server, Shield, Users, Target } from 'lucide-react';
import Image from 'react-bootstrap/Image';
import dedupHeroImg from '../assets/images/Marketing/Data-dedup.jpg';
import ComsenseSolution from '../assets/images/Marketing/fs.jpg';

const DataDeduplicationEngine = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');
        .dedup-page { font-family: 'Outfit', sans-serif; background-color: #fff; }
        .dedup-page * { font-family: 'Outfit', sans-serif; }

        /* Hero Section (Revamped to match AWS Middleware) */
        .hero-section-dedup {
          padding: 80px 0;
          background: #fff;
          position: relative;
          overflow: hidden;
        }

        .hero-image-wrapper {
          position: relative;
          display: inline-block;
          z-index: 1;
          width: 100%;
        }

        .hero-shape {
          position: absolute;
          z-index: -1;
          opacity: 0.1;
          animation: float 6s ease-in-out infinite;
        }

        .hero-shape-square {
          width: 80px;
          height: 80px;
          background: #ee0000;
          top: -10px;
          right: -10px;
          border-radius: 12px;
          transform: rotate(15deg);
        }

        .hero-shape-square-2 {
          width: 60px;
          height: 60px;
          background: #067bb1;
          bottom: -15px;
          left: -15px;
          border-radius: 10px;
          transform: rotate(-15deg);
        }

        @keyframes float {
          0%, 100% { transform: translate(0, 0) rotate(15deg); }
          50% { transform: translate(10px, -20px) rotate(20deg); }
        }

        @keyframes float-tri {
          0%, 100% { transform: translate(0, 0) rotate(-15deg); }
          50% { transform: translate(-15px, 15px) rotate(-10deg); }
        }
        
        .hero-tag-dedup { 
          display:inline-flex; 
          align-items:center; 
          gap:8px; 
          padding:6px 12px; 
          border-radius:999px; 
          background:#ffefef; 
          color:#ee0000; 
          border:1px solid #ffd4d4; 
          font-weight:700; 
          font-size:12px; 
          margin-bottom: 16px;
        }

        .hero-title-dedup {
          font-size: 42px;
          font-weight: 800;
          color: #000;
          margin-bottom: 12px;
          line-height: 1.1;
          letter-spacing: -0.02rem;
        }
        
        .highlight-red-dedup { color:#ee0000;font-weight:700; }

        .hero-subtitle-dedup {
          font-size: 20px;
  color: #2c354c;
  font-weight: 400;
  margin-bottom: 24px;
  letter-spacing: -0.01rem;
  max-width: 100%;
        }

        .hero-chip-row-dedup { 
          display:flex; 
          gap:12px; 
          flex-wrap:wrap; 
          margin:24px 0; 
        }

        .stat-card-dedup { 
          display:flex; 
          align-items:center; 
          gap:12px; 
          padding:12px 16px; 
          border-radius:16px; 
          background:#fff; 
          border:1px solid #e6edf5; 
          box-shadow:0 2px 0 rgba(0,0,0,0.04); 
        }
        
        .stat-icon-dedup { 
          width:36px; 
          height:36px; 
          border-radius:12px; 
          display:flex; 
          align-items:center; 
          justify-content:center; 
          border:1px solid transparent; 
        }
        
        .stat-icon-green-dedup { background:#f0fff5; border-color:#d7fbe7; color:#10b981; }
        .stat-icon-orange-dedup { background:#fff7ed; border-color:#fde2c5; color:#f59e0b; }
        .stat-icon-pink-dedup { background:#fdf2f6; border-color:#f8d7e5; color:#ef4444; }
        
        .stat-label-dedup { font-size:12px; color:#64748b; font-weight: 500; }
        .stat-value-dedup { font-size:16px; font-weight:800; color:#0f172a; }

        .hero-description-dedup {
          font-size: 16px;
          line-height: 1.6;
          color: #334155;
          margin-bottom: 32px;
          max-width: 90%;
        }

        .btn-red-dedup { 
          text-decoration:none;
          background:#ee0000; 
          color:#fff; 
          border:none; 
          border-radius:12px; 
          padding:12px 24px; 
          font-weight:700; 
          box-shadow:0 12px 24px rgba(238,0,0,0.18); 
          transition: all 0.3s ease;
          display: inline-block;
        }
        .btn-red-dedup:hover {
          background: #cc0000;
          transform: translateY(-2px);
          color: #fff;
        }

        .hero-visual-container-dedup {
          position: relative;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 20px 50px rgba(0,0,0,0.1);
          margin: auto;
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 300px;
        }

        /* Problem Section (Revamped to match AWS Middleware) */
        .problem-section-dedup {
          padding: 80px 0;
          background: #e2f1fe;
          position: relative;
          overflow: hidden;
        }
        
        .dedup-ps-bg-orb {
          position: absolute;
          width: 400px;
          height: 400px;
          // background: radial-gradient(circle, rgba(227, 24, 55, 0.05) 0%, transparent 70%);
          border-radius: 50%;
          filter: blur(100px);
          z-index: 0;
          pointer-events: none;
        }
        .dedup-ps-orb-tl { top: -100px; left: -100px; }
        .dedup-ps-orb-br { bottom: -100px; right: -100px; }

        .dedup-ps-pill {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 6px 16px;
          border-radius: 999px;
          background: #ffefef;
          color: #ee0000;
          border: 1px solid #ffd4d4;
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 15px;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }
        
        .dedup-ps-title {
          font-size: 42px;
          font-weight: 800;
          color: #000;
          margin-bottom: 15px;
          letter-spacing: -0.02em;
        }
        
        .dedup-ps-text {
          font-size: 18px;
          line-height: 1.6;
          color: #4b5563;
          margin-bottom: 20px;
        }

        .dedup-problem-card-modern {
          background: #fff;
          border-radius: 24px;
          padding: 32px 24px;
          border: 1px solid #e2e8f0;
          height: 100%;
          position: relative;
          overflow: hidden;
          transition: all 0.4s ease;
          z-index: 1;
        }
        .dedup-problem-card-modern:hover {
          border-color: #fee2e2;
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.06);
        }
        
        .dedup-problem-icon-box {
          width: 64px;
          height: 64px;
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
          position: relative;
          z-index: 2;
          background: #ee0000;
          color: #fff;
          box-shadow: 0 8px 20px rgba(238, 0, 0, 0.25);
          transition: transform 0.3s ease;
        }
        .dedup-problem-card-modern:hover .dedup-problem-icon-box {
          transform: scale(1.1) rotate(-5deg);
        }
        
        .dedup-problem-card-title {
          font-size: 20px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 12px;
          transition: color 0.3s ease;
          padding-bottom: 0px;
        }
        .dedup-problem-card-modern:hover .dedup-problem-card-title {
          color: #ee0000;
        }
        
        .dedup-problem-card-text {
          font-size: 14px;
          color: #64748b;
          line-height: 1.5;
        }
        
        .dedup-shape-tr-circle { 
            position: absolute; 
            top: -60px; 
            right: -60px; 
            width: 150px; 
            height: 150px; 
            border-radius: 50%; 
            background: transparent;
            border: 1px solid rgba(238, 0, 0, 0.1);
            z-index: 0;
            pointer-events: none;
        }
        
        .dedup-shape-tr-inner {
            position: absolute;
            top: -30px;
            right: -30px;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background: radial-gradient(circle at center, rgba(238, 0, 0, 0.04) 0%, transparent 70%);
            z-index: 0;
        }
        
        .dedup-shape-diamond { 
            position: absolute; 
            top: 20px; 
            right: 20px; 
            width: 12px; 
            height: 12px; 
            background: #fee2e2; 
            transform: rotate(45deg); 
            opacity: 0; 
            transition: all 0.4s ease; 
        }
        .dedup-problem-card-modern:hover .dedup-shape-diamond { 
            opacity: 1; 
            transform: rotate(45deg) translate(10px, -10px); 
        }
        
        .dedup-ps-footer {
          font-size: 18px;
          margin-top: 24px;
          padding-top: 24px;
          border-top: 1px solid #e5e7eb;
          color: #1f2937;
        }

        /* Solution Section (Revamped to match AWS Middleware) */
        .solution-section-dedup {
          background: #fff;
          padding: 80px 0;
          position: relative;
          overflow: hidden;
        }
        
        .dedup-solution-container {
          position: relative;
          background: #fff;
          border-radius: 32px;
          padding: 60px;
          border: 1px solid rgba(56, 164, 229, 0.2);
          box-shadow: 0 20px 50px -12px rgba(24, 132, 227, 0.1);
          z-index: 1;
        }

        .dedup-sol-icon-wrapper {
          width: 56px;
          height: 56px;
          border-radius: 16px;
          background: linear-gradient(135deg, #ee0000, #cc0000);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          margin-bottom: 24px;
          box-shadow: 0 10px 20px rgba(238, 0, 0, 0.2);
        }

        /* Key Capabilities Section (Revamped to Modern Feature List) */
        .capabilities-section-dedup {
          padding: 80px 0;
          background-color: #effdff;
          position: relative;
          overflow: hidden;
        }
        
        .cap-feature-row {
          display: flex;
          align-items: center;
          padding: 32px;
          background: #fff;
          border-radius: 24px;
          border: 1px solid #e2e8f0;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          height: 100%;
          position: relative;
          z-index: 1;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          overflow: hidden;
        }
        
        .cap-feature-row:hover {
          border-color: #fee2e2;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
          transform: translateY(-5px);
        }

        .cap-feature-row .dedup-shape-tr-circle { 
            position: absolute; 
            top: -60px; 
            right: -60px; 
            width: 150px; 
            height: 150px; 
            border-radius: 50%; 
            background: transparent;
            border: 1px solid rgba(238, 0, 0, 0.1);
            z-index: 0;
            pointer-events: none;
        }
        
        .cap-feature-row .dedup-shape-tr-inner {
            position: absolute;
            top: -30px;
            right: -30px;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background: radial-gradient(circle at center, rgba(238, 0, 0, 0.04) 0%, transparent 70%);
            z-index: 0;
        }
        
        .cap-feature-row .dedup-shape-diamond { 
            position: absolute; 
            top: 20px; 
            right: 20px; 
            width: 12px; 
            height: 12px; 
            background: #fee2e2; 
            transform: rotate(45deg); 
            opacity: 0; 
            transition: all 0.4s ease; 
        }
        .cap-feature-row:hover .dedup-shape-diamond { 
            opacity: 1; 
            transform: rotate(45deg) translate(10px, -10px); 
        }

        .cap-feature-icon-box {
          width: 64px;
          height: 64px;
          border-radius: 16px;
          background: #ffefef;
          color: #ee0000;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 24px;
          flex-shrink: 0;
          transition: all 0.4s ease;
        }
        
        .cap-feature-row:hover .cap-feature-icon-box {
          background: #ee0000;
          color: #fff;
          transform: rotate(-10deg);
        }

        .cap-feature-content {
          flex-grow: 1;
        }

        .cap-feature-title {
          font-size: 18px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 0;
          line-height: 1.4;
          transition: color 0.3s ease;
        }
        
        .cap-feature-row:hover .cap-feature-title {
          color: #ee0000;
        }

        .cap-accent-blob {
          position: absolute;
          top: -20px;
          right: -20px;
          width: 100px;
          height: 100px;
          background: radial-gradient(circle, rgba(238, 0, 0, 0.03) 0%, transparent 70%);
          z-index: -1;
          border-radius: 50%;
        }

        /* Business Impact Section (Revamped to Dashboard Style) */
        .impact-section-dedup {
          padding: 80px 0;
          background-color: #fff;
          position: relative;
          overflow: hidden;
        }
        
        .impact-stat-card {
          background: #fff;
          border-radius: 20px;
          padding: 32px;
          border: 1px solid #e2e8f0;
          height: 100%;
          transition: all 0.4s ease;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          overflow: hidden;
          z-index: 1;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        }
        .impact-stat-card:hover {
          transform: translateY(-8px);
          border-color: #fee2e2;
          box-shadow: 0 20px 40px rgba(0,0,0,0.06);
        }
        
        .impact-stat-card .dedup-shape-tr-circle { 
            position: absolute; 
            top: -60px; 
            right: -60px; 
            width: 150px; 
            height: 150px; 
            border-radius: 50%; 
            background: transparent;
            border: 1px solid rgba(238, 0, 0, 0.1);
            z-index: 0;
            pointer-events: none;
        }
        
        .impact-stat-card .dedup-shape-tr-inner {
            position: absolute;
            top: -30px;
            right: -30px;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background: radial-gradient(circle at center, rgba(238, 0, 0, 0.04) 0%, transparent 70%);
            z-index: 0;
        }
        
        .impact-stat-card .dedup-shape-diamond { 
            position: absolute; 
            top: 20px; 
            right: 20px; 
            width: 12px; 
            height: 12px; 
            background: #fee2e2; 
            transform: rotate(45deg); 
            opacity: 0; 
            transition: all 0.4s ease; 
        }
        .impact-stat-card:hover .dedup-shape-diamond { 
            opacity: 1; 
            transform: rotate(45deg) translate(10px, -10px); 
        }

        .impact-icon-box {
          width: 64px;
          height: 64px;
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
          position: relative;
          z-index: 2;
          background: #ee0000;
          color: #fff;
          box-shadow: 0 8px 20px rgba(238, 0, 0, 0.25);
          transition: all 0.3s ease;
        }
        .impact-stat-card:hover .impact-icon-box {
          transform: scale(1.1) rotate(-5deg);
          box-shadow: 0 12px 24px rgba(238, 0, 0, 0.4);
        }
        
        .impact-stat-title {
          font-size: 20px;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 12px;
          transition: color 0.3s ease;
        }
        .impact-stat-card:hover .impact-stat-title {
          color: #ee0000;
        }
        
        .impact-stat-desc {
          font-size: 15px;
          color: #64748b;
          line-height: 1.6;
        }

        .impact-accent-line {
          width: 40px;
          height: 4px;
          background: #ee0000;
          border-radius: 2px;
          margin-bottom: 20px;
        }
          .solution-highlight {
  color: #ee0000;
  font-weight: 700;
}
  .dedup-cap-badge
      {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 999px;
  background: #ffefef;
  color: #e00;
  border: 1px solid #ffd4d4;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
      }
      `}</style>
      <div className="dedup-page">
        {/* Hero Section */}
        <section className="hero-section-dedup">
          <Container>
            <Row className="align-items-center justify-content-between">
              <Col lg={7}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  {/* <div className="hero-tag-dedup mb-3">⚡ Data Deduplication Layer</div> */}
                  {/* <h1 className="hero-title-dedup mb-2">
                    Eliminate Duplicate Customer Records With
                    <span className="highlight-red-dedup"> 99%+ Accuracy</span>
                  </h1> */}
                  <h1 className="hero-title-dedup mb-2">
                    PySpark
                  </h1>
                  <p className="hero-subtitle-dedup">A machine learning–driven data de-duplication engine designed for high-volume Salesforce Data Cloud environments.</p>





                  <div className="d-flex gap-3 mt-4">
                    <a href="/contact" className="btn-red-dedup">Schedule Consultation</a>
                  </div>
                </motion.div>
              </Col>
              <Col lg={5} className="text-center">
                <div className="hero-image-wrapper">
                  <div className="hero-shape hero-shape-square"></div>
                  <div className="hero-shape hero-shape-square-2" style={{ animationName: 'float-tri' }}></div>
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1 }}
                  >
                    <Image src={dedupHeroImg} className="w-100" alt="Data De-duplication" />
                  </motion.div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Problem Section */}
        <section className="problem-section-dedup">
          <div className="dedup-ps-bg-orb dedup-ps-orb-tl"></div>
          <div className="dedup-ps-bg-orb dedup-ps-orb-br"></div>
          <Container>
            <div className="text-center mb-5">
              {/* <div className="dedup-ps-pill">The Challenge</div> */}
              <h2 className="dedup-ps-title">The Problem</h2>
              <p className="dedup-ps-text mx-auto" style={{ maxWidth: '700px' }}>
                Duplicate customer records create major challenges in cloud environments:               </p>
            </div>

            <Row className="g-4 mb-5">
              {[
                { icon: <Users size={28} />, title: "Fragmented customer identities" },
                { icon: <Target size={28} />, title: "Inaccurate segmentation" },
                { icon: <TrendingDown size={28} />, title: "Reduced personalization effectiveness" },
                { icon: <DollarIcon size={28} />, title: "Increased processing costs" }
              ].map((item, idx) => (
                <Col key={idx} md={6} xl={3}>
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: idx * 0.1 }}
                    className="dedup-problem-card-modern"
                  >
                    <div className="dedup-shape-tr-circle"></div>
                    <div className="dedup-shape-tr-inner"></div>
                    <div className="dedup-shape-diamond"></div>
                    <div className="dedup-problem-icon-box">
                      {item.icon}
                    </div>
                    <h4 className="dedup-problem-card-title mb-0">{item.title}</h4>
                  </motion.div>
                </Col>
              ))}
            </Row>

            <div className="text-center">
              <p className="dedup-ps-text fs-4 mb-0">
                Traditional rule-based approaches <span className="highlight-red-dedup">cannot handle large-scale datasets and inconsistent attributes.</span>
              </p>
            </div>
          </Container>
        </section>

        {/* Solution Section */}
        <section className="solution-section-dedup">
          <Container>
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="dedup-solution-container"
            >
              <Row className="align-items-center">
                <Col lg={8}>
                  <h2 className="dedup-ps-title">Comsense Solution</h2>
                  <p className="ps-text fs-5 mb-4">
                    Our <span className="solution-highlight">Data De-duplication Engine</span> uses <span className="solution-highlight-dedup">distributed PySpark processing</span> and <span className="solution-highlight-dedup">machine learning-driven fuzzy matching</span> to automatically detect and merge duplicate records across datasets.
                  </p>
                  <p className="ps-text fs-5 mb-0">
                    This ensures<span className="solution-highlight"> clean, reliable customer profiles ready for segmentation, analytics, and personalization.
                    </span></p>
                </Col>
                <Col lg={4} className="d-none d-lg-flex justify-content-end">
                  <Image src={ComsenseSolution} alt="The Solution" className="img-fluid" />
                </Col>
              </Row>
            </motion.div>
          </Container>
        </section>

        {/* Key Capabilities */}
        <section className="capabilities-section-dedup">
          <Container>
            <div className="text-center mb-5">
              {/* <div className="dedup-ps-pill">Core Features</div> */}
              <h2 className="dedup-ps-title">Key Capabilities</h2>
            </div>

            <Row className="g-4 justify-content-center">
              {[
                { icon: <CheckCircle size={32} />, text: "Automated data standardization" },
                { icon: <Zap size={32} />, text: "ML-powered fuzzy matching algorithms" },
                { icon: <Users size={32} />, text: "Identity consolidation and profile merging" },
                { icon: <Server size={32} />, text: "3x faster distributed processing with PySpark" },
                { icon: <Shield size={32} />, text: "Governance-ready data quality frameworks" }
              ].map((item, idx) => (
                <Col md={6} lg={4} key={idx}>
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: idx * 0.1 }}
                    className="cap-feature-row"
                  >
                    <div className="dedup-shape-tr-circle"></div>
                    <div className="dedup-shape-tr-inner"></div>
                    <div className="dedup-shape-diamond"></div>
                    <div className="cap-accent-blob"></div>
                    <div className="cap-feature-icon-box">
                      {item.icon}
                    </div>
                    <div className="cap-feature-content">
                      <h4 className="cap-feature-title">{item.text}</h4>
                    </div>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* Business Impact */}
        <section className="impact-section-dedup">
          <Container>
            <Row className="align-items-center">
              <Col lg={4}>
                <div className="mb-5 mb-lg-0">
                  {/* <div className="dedup-cap-badge">
                    <div className="dedup-cap-badge-dot"></div>
                    The Results
                  </div> */}
                  <h2 className="dedup-ps-title">Business Impact</h2>
                  <p className="dedup-ps-text">
                    Our machine learning-driven approach delivers measurable improvements in data quality and marketing performance.
                  </p>
                  <div className="d-none d-lg-block mt-4">
                    <a href="/contact" className="btn-red-dedup">Assess Data Quality</a>
                  </div>
                </div>
              </Col>

              <Col lg={8}>
                <Row className="g-4">
                  {[
                    { icon: <CheckCircle size={32} />, title: "99%+ duplicate elimination accuracy " },
                    { icon: <DollarIcon size={32} />, title: "Reduced data processing overhead " },
                    { icon: <Target size={32} />, title: "More precise customer segmentation and targeting " },
                    { icon: <Users size={32} />, title: "Improved personalization performance " }
                  ].map((item, idx) => (
                    <Col md={6} key={idx}>
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: idx * 0.1 }}
                        className="impact-stat-card"
                      >
                        <div className="dedup-shape-tr-circle"></div>
                        <div className="dedup-shape-tr-inner"></div>
                        <div className="dedup-shape-diamond"></div>
                        <div className="impact-icon-box">
                          {item.icon}
                        </div>
                        <h4 className="impact-stat-title mb-0 pb-0">{item.title}</h4>
                      </motion.div>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
};

export default DataDeduplicationEngine;

const DollarIcon = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
);
